import { NavigationItem } from './NavigationItem';

export const AdminNavigation = () => {
  return (
    <div className="flex w-screen items-center gap-8 bg-primary-black-90 px-8 py-5 text-sm text-secondary-grey-05">
      <NavigationItem
        linkTo={`/admin/user-access-management`}
        navigationLabel="User access management"
      ></NavigationItem>
      <NavigationItem linkTo={`/admin/remove-academics`} navigationLabel="Remove academics"></NavigationItem>
      <NavigationItem linkTo={`/admin/remove-units`} navigationLabel="Remove units"></NavigationItem>
      <NavigationItem linkTo={`/admin/school-parameters`} navigationLabel="Modify school parameters"></NavigationItem>
      <NavigationItem linkTo={`/admin/disciplines`} navigationLabel="Disciplines"></NavigationItem>
      <NavigationItem linkTo={`/admin/update-staff-details`} navigationLabel="Update staff details"></NavigationItem>
      <NavigationItem linkTo={`/admin/data-load`} navigationLabel="Data load"></NavigationItem>
      <NavigationItem linkTo={`/admin/hdr-allocations`} navigationLabel="HDR allocations"></NavigationItem>
    </div>
  );
};
